import { useEffect, useState } from "react";

/**
 * hook for countdown to a deadline.
 * @param {Number} deadline the timestamp in milliseconds of the deadline.
 * @returns {Object} returns an object {
		remainingDays,
		remainingHours,
		remainingMinutes,
		remainingSeconds
	}
 */

export const useCountdown = (deadline) => {
	const [remainingDays, setRemainingDays] = useState();
	const [remainingHours, setRemainingHours] = useState();
	const [remainingMinutes, setRemainingMinutes] = useState();
	const [remainingSeconds, setRemainingSeconds] = useState();

	function countdown() {
		const now = new Date().getTime();
		const timeLeft = deadline - now;

		if (timeLeft < 0) {
			setRemainingDays(0);
			setRemainingHours(0);
			setRemainingMinutes(0);
			setRemainingSeconds(0);
			return;
		}

		const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
		const hours = Math.floor(
			(timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
		);
		const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

		setRemainingDays(days);
		setRemainingHours(hours);
		setRemainingMinutes(minutes);
		setRemainingSeconds(seconds);
	}

	useEffect(() => {
		const interval = setInterval(countdown, 1000);
		return () => clearInterval(interval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		remainingDays,
		remainingHours,
		remainingMinutes,
		remainingSeconds
	};
};
